import { createFileRoute } from '@tanstack/react-router'
import { Categories } from '@/features/categories'

// Per-column text filter (example for username)

export const Route = createFileRoute('/_authenticated/categories/')({
  component: Categories,
})
